import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-title">quick links</h3>
            <nav className="footer-nav">
              <Link to="/shop" onClick={toTop}>
                shop
              </Link>
              <Link to="/contact" onClick={toTop}>
                contact
              </Link>
              <Link to="/shipping" onClick={toTop}>
                shipping
              </Link>
              <Link to="/returns" onClick={toTop}>
                refund policy
              </Link>
              <Link to="/privacy" onClick={toTop}>
                privacy policy
              </Link>
              <Link to="/cookies" onClick={toTop}>
                cookie policy
              </Link>
              <Link to="/faq" onClick={toTop}>
                faqs
              </Link>
              <Link to="/terms" onClick={toTop}>
                terms of service
              </Link>
            </nav>
          </div>
          <div className="footer-section">
            <h3 className="footer-title">about us</h3>
            <p className="footer-about-text">
              tunrisefield offers a limited selection of high
              quality paper products designed for use with fountain pens. our
              online store is operated from hong kong.
            </p>
          </div>
        </div>
        <div className="footer-contact-area">
          <div className="contact-section">
            <h3 className="footer-title">Stay Connected</h3>
            <p><a href="mailto:mall@tunrisefield.xyz">mall@tunrisefield.xyz</a></p>
            <p>182 Howard Street #206, San Francisco, CA 94105</p>
            <div className="payment-methods" aria-label="Supported payment methods">
              <span>VISA</span><span>Mastercard</span><span>AMEX</span><span>Discover</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-copyright">
        <div className="footer-container">
          <p>
            © 2026, tunrisefield ·
            <Link to="/returns" onClick={toTop}>
              Refund policy
            </Link>{" "}
            ·
            <Link to="/privacy" onClick={toTop}>
              Privacy policy
            </Link>{" "}
            ·
            <Link to="/cookies" onClick={toTop}>
              Cookie policy
            </Link>{" "}
            ·
            <Link to="/terms" onClick={toTop}>
              Terms of service
            </Link>{" "}
            ·
            <Link to="/shipping" onClick={toTop}>
              Shipping policy
            </Link>{" "}
            ·
            <Link to="/contact" onClick={toTop}>
              Contact information
            </Link>{" "}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
